import React from 'react';

const EditableFields = ({cintaTestigo, setCintaTestigo, observations, setObservations, disable}) => {
  return (
    <div>
      <div className="columns">
        <div className="column is-half">
          <div className="field">
            <div className="control is-expanded">
              <label htmlFor="">Link descarga cinta testigo:</label>
              <textarea disabled={disable} className="textarea" placeholder="'http://'" value={cintaTestigo} onChange={(e) => setCintaTestigo(e.target.value)} />
            </div>
          </div>
        </div>
      </div>
      <div className="field">
        <label className="label">Observaciones Generales:</label>
        <textarea disabled={disable} className="textarea" placeholder="" value={observations} onChange={(e) => setObservations(e.target.value)}></textarea>
      </div>
    </div>
  )
}

export default EditableFields;